export const DEFAULT_RULE = 'RULE 1';
